import {IFlatBooster} from "../../types/booster_generic/IFlatBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {areOfferLeftPropertiesStatsValid} from "../../utils/offer_stats/are_offer_left_properties_stats_valid";
import {getOfferStatsByRooms} from "../../utils/offer_stats/get_offer_stats_by_rooms";
import {getLastFlatPropertyText} from "../../utils/texts/last_property_text";

export const flatRoomsBooster: IFlatBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Room,

    isValid(params) {
        const stats = getOfferStatsByRooms(params.property.rooms, params.property.offer.stats?.building_parameters_stats);

        return areOfferLeftPropertiesStatsValid(stats);
    },

    getSegments(params) {
        const stats = getOfferStatsByRooms(params.property.rooms, params.property.offer.stats?.building_parameters_stats);

        if (!stats || !stats.left || !stats.label) {
            return null;
        }

        return [
            "Złap okazję! To",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${getLastFlatPropertyText(stats.left)}`
            },
            `${stats.label} w tej inwestycji.`
        ];
    }
};
import {IFlatBooster} from "../../types/booster_generic/IFlatBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {areOfferLeftPropertiesStatsValid} from "../../utils/offer_stats/are_offer_left_properties_stats_valid";
import {getOfferStatsByRooms} from "../../utils/offer_stats/get_offer_stats_by_rooms";
import {getLastFlatPropertyText} from "../../utils/texts/last_property_text";

export const flatRoomsBooster: IFlatBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Room,

    isValid(params) {
        const stats = getOfferStatsByRooms(params.property.rooms, params.property.offer.stats?.building_parameters_stats);

        return areOfferLeftPropertiesStatsValid(stats);
    },

    getSegments(params) {
        const stats = getOfferStatsByRooms(params.property.rooms, params.property.offer.stats?.building_parameters_stats);

        if (!stats || !stats.left || !stats.label) {
            return null;
        }

        return [
            "Złap okazję! To",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${getLastFlatPropertyText(stats.left)}`
            },
            `${stats.label} w tej inwestycji.`
        ];
    }
};
